export default __webpack_public_path__ + "static/media/cx_cover_cal11s.a2900bb6.jpeg";